import { useState } from 'react';

import { validateState } from './useForm/validate';

export const useValidateState = (validator, defaultValue, required, translate) => {
    const [errorText, changeError] = useState((validateState(validator, defaultValue, required, translate) || {}).errorText);

    return [errorText, changeError];
};
